var map = {
	"./EOL-empty.svg": "6e62",
	"./EOL.svg": "1be0",
	"./PCH-empty.svg": "8398",
	"./PCH.svg": "3cb8",
	"./SOL-empty-bkp.svg": "a863",
	"./SOL-empty.svg": "8773",
	"./SOL.svg": "6e79",
	"./UTE-empty.svg": "c781",
	"./UTE.svg": "f853",
	"./align-left.svg": "cec7",
	"./apps.svg": "caf4",
	"./arrow-down.svg": "6ddf",
	"./arrow-up.svg": "f658",
	"./assignment.svg": "7bf5",
	"./attachment.svg": "ee29",
	"./bolt.svg": "7197",
	"./business.svg": "e888",
	"./calendar.svg": "b886",
	"./cloud-cloud.svg": "4168",
	"./cloud-rain.svg": "ca00",
	"./cloud-raining.svg": "c001",
	"./cloud-sun.svg": "075a",
	"./cloud.svg": "644e",
	"./co2.svg": "5b12",
	"./comment.svg": "3450",
	"./config.svg": "f2e1",
	"./domain.svg": "43fd",
	"./drop-invert.svg": "59a4",
	"./empty-solar-panel.svg": "55cc",
	"./empty-turbine.svg": "d01d",
	"./empty-wind-turbine.svg": "24d4",
	"./file_download.svg": "4b7a",
	"./fullscreen.svg": "2eb3",
	"./goals.svg": "247f",
	"./home.svg": "e30a",
	"./house.svg": "bafd",
	"./ice.svg": "0940",
	"./info.svg": "4573",
	"./list.svg": "3ae0",
	"./logo-automalogica-branco.svg": "d5cf",
	"./maximize-alt.svg": "91ad",
	"./memory.svg": "4931",
	"./menu-left.svg": "9a98",
	"./people.svg": "09dc",
	"./poll.svg": "d8fb",
	"./software-download.svg": "2ead",
	"./software-upload.svg": "13e7",
	"./solar-panel.svg": "d2ad",
	"./sticky_note.svg": "e903",
	"./sun-cloud-raining.svg": "b118",
	"./sun.svg": "05fd",
	"./thermostat.svg": "8f55",
	"./timelapse.svg": "773a",
	"./tracker-empty.svg": "6678",
	"./tree.svg": "337a",
	"./trending.svg": "2624",
	"./turbine.svg": "e43f",
	"./undefined.svg": "a2f0",
	"./under-development.svg": "fc5b",
	"./update.svg": "df3e",
	"./waring-empty.svg": "1fc2",
	"./waring.svg": "5969",
	"./wind-turbine.svg": "ebea",
	"./wind.svg": "f403",
	"./windy.svg": "6072",
	"./work.svg": "3f83"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "78e8";